"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatsData = exports.getConfiguration = exports.configure = void 0;
var commonProperties_1 = require("./lib/commonProperties");
var GLOBAL_CACHE_KEY = '__TIENDEO_STATS_CLIENT__';
var GLOBAL_STORAGE;
var isConfigured = function () { return GLOBAL_STORAGE !== undefined && GLOBAL_STORAGE[GLOBAL_CACHE_KEY]; };
var initDefaultValues = function (statsData) {
    if (!statsData.OpeningHash)
        statsData.OpeningHash = commonProperties_1.generateOpeningHash();
    return statsData;
};
function configure(config, statsData) {
    GLOBAL_STORAGE = typeof window === 'undefined' ? {} : window;
    if (!isConfigured()) {
        GLOBAL_STORAGE[GLOBAL_CACHE_KEY] = {};
    }
    initDefaultValues(statsData);
    GLOBAL_STORAGE[GLOBAL_CACHE_KEY].Configs = config;
    GLOBAL_STORAGE[GLOBAL_CACHE_KEY].StatsData = statsData;
}
exports.configure = configure;
function getCache() {
    if (!isConfigured()) {
        throw new Error('[TIENDEO-STATS-CLIENT] Not configured. Please check documentation.');
    }
    return GLOBAL_STORAGE[GLOBAL_CACHE_KEY];
}
function getConfiguration() {
    return getCache().Configs;
}
exports.getConfiguration = getConfiguration;
function getStatsData() {
    return getCache().StatsData;
}
exports.getStatsData = getStatsData;
//# sourceMappingURL=config.js.map